import http from "./http";

class HttpError extends Error {
	constructor(message, statusCode) {
		super(message);
		this.statusCode = statusCode;
		Object.setPrototypeOf(this, HttpError.prototype);
	}
}

const handleRequestError = (error) => {
	if (error.response) {
		const { status, data } = error.response;
		const errorMessage = (data && data.message) || "Unknown server error";
		throw new HttpError(errorMessage, status);
	} else if (error.request) {
		throw new HttpError(
			"Network Error: The request was made but no response was received.",
			500
		);
	} else {
		throw new HttpError(`Request Error: ${error.message}`, 500);
	}
};

export const httpGet = async (
	url,
	params = {},
	headers = {}
) => {
	try {
		const response = await http.get(url, { params, headers });
		return response.data;
	} catch (error) {
		handleRequestError(error);
		return Promise.reject(error);
	}
};

export const httpPost = async (
	url,
	data = {},
	headers = {}
) => {

	try {
		const token = localStorage.getItem('access');
		const authHeaders = token
			? { Authorization: `Bearer ${token}`, ...headers }
			: headers;
		const response = await http.post(url, data, { headers: authHeaders });
		return response.data;
	} catch (error) {
		handleRequestError(error);
		return Promise.reject(error);
	}
};

export const httpPostform = async (
	url,
	data,
	headers = {}
) => {
	try {
		const token = localStorage.getItem('access');
		let finalHeaders = {
			...headers,
		};
		finalHeaders['Content-Type'] = 'multipart/form-data';
		const response = await http.post(url, data, {
			headers: finalHeaders,
		});
		return response.data;
	} catch (error) {
		handleRequestError(error);
		return Promise.reject(error);
	}
};

export const httpPut = async (
	url,
	data = {},
	headers = {}
) => {
	try {
		const response = await http.put(url, data, { headers });
		return response.data;
	} catch (error) {
		handleRequestError(error);
		return Promise.reject(error);
	}
};

export const httpDelete = async (
	url,
	headers = {}
) => {
	try {
		const response = await http.delete(url, { headers });
		return response.data;
	} catch (error) {
		handleRequestError(error);
		return Promise.reject(error);
	}
};
